import { createContext } from 'react';

import type { TimeGapPolicy } from '../../core/types/gap-policy.js';
import { defaultGapPolicy } from '../constants.js';

export const TimeseriesGapPolicyContext =
  createContext<TimeGapPolicy>(defaultGapPolicy);

TimeseriesGapPolicyContext['displayName'] = 'TimeseriesGapPolicyContext';
